'use client';

import { createContext, useContext } from 'react';

const DraftModeContext = createContext(false);
export const useDraftMode = () => useContext(DraftModeContext);

export default function DraftModeProvider({
    enabled,
    children
}: {
    enabled: boolean;
    children: React.ReactNode;
}) {
    return (
        <DraftModeContext.Provider value={enabled}>
            {children}
        </DraftModeContext.Provider>
    );
}
